import { createSelector } from 'reselect';
import { filter } from 'lodash';

const getLessons    = (state) => state.lesson.entities;
const getFilters    = (state) => state.filter;
const getFavorites  = (state) => state.authentication.user && state.authentication.user.favorites;

const levelOrderning = {
    Intro: 1,
    Basis: 2,
    Gevorderd: 3,
    Expert: 4

}

const typeOrdering = {
    card: 0,
    artcard: 1,
    eventcard: 2,
    workshopcard: 3
    
}

const getFilteredProjects = createSelector(
    [getFilters, getLessons, getFavorites],
    (filters, lessons, favorites) => {
        //begin actual filtering
        return lessons.allIds.map(lessonId => {
            return lessons.byId[lessonId];
        })
            // filter on favorites
            .filter(lesson => {
                //if both return true
                if(filters.types.includes('favorieten')) {
                    return favorites.includes(lesson.id)
                }
                return true;
            })
            
            .filter(lesson => {
                if(filters.levels.length > 0) {

                    return filters.levels.includes(lesson.level);
                }
                return true;
            })

            .filter((lesson) => {
                if(filters.name != '') {
                    return lesson.name.toLowerCase().includes(filters.name.toLowerCase());
                } 

                return true;
            })
            .filter((lesson) => {
                if(lesson.time_min < filters.minTime || lesson.time_max > filters.maxTime) {
                    return false;
                } else {
                    return true;
                }
            })
            .filter(lesson => {
                if(filters.types.length > 0) {
                    if(filters.types.includes('plugged')) {
                        return lesson.plugged;
                    }
                    if(filters.types.includes('unplugged')) {
                        return !lesson.plugged;
                    }
                    if(filters.types.includes('group')) {
                        return lesson.group_lesson;
                    }
                    if(filters.types.includes('individual')) {
                        return lesson.individual_lesson
                    }
                    if(filters.types.includes('po')) {
                        return lesson.po;
                    }
                    if(filters.types.includes('vo')) {
                        return lesson.vo;
                    }

                    //filter on card type
                    if (filters.types.includes('kunstwerk')){
                        return lesson.type == 'artcard';
                    } 
                    if (filters.types.includes('event')){
                        return lesson.type == 'eventcard';
                    }
                    if (filters.types.includes('workshop')){
                        return lesson.type == 'workshopcard';
                    } 
                    if (filters.types.includes('les')){
                        return lesson.type == 'card';
                    }
                }
                return true;
            })
            .sort((a, b) => {
                if(filters.sort == 'date'){
                    let date_a = new Date(a.created_at);
                    let date_b = new Date(b.created_at);
                    return date_b - date_a;
                } 
                else if(filters.sort == 'code-techniek'){
                    return b['code-tech-percentage'] - a['code-tech-percentage'];
                } 
                else if(filters.sort == 'art'){
                    return b['art-creativity-percentage'] - a['art-creativity-percentage'];
                } 
                else if(filters.sort == 'thinking'){
                    return b['critical-thinking-percentage'] - a['critical-thinking-percentage'];
                } 
                else if(filters.sort == 'duration'){
                    return a.time_min - b.time_min;
                } 
                else{
                    //first sort on level
                    if (levelOrderning[a.level] < levelOrderning[b.level] ) return -1;
                    if (levelOrderning[a.level] > levelOrderning[b.level] ) return 1;
                    //then sort on cardtype
                    if (typeOrdering[a.type] < typeOrdering[b.type] ) return -1;
                    if (typeOrdering[a.type] > typeOrdering[b.type] ) return 1;
                    
                    return 0;
                }
            })
        
    }
);

export default getFilteredProjects;
